import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Loader.css';

class Loader extends React.Component {

  render() {
    const color = this.props.light ? '255, 255, 255' : '119, 119, 119';
    const loaderStyles = this.props.block
      ? classNames(s.Loader, s.Loader__block)
      : classNames(s.Loader);

    return (
      <div className={loaderStyles}>
        <svg className={s.Loader_svg} xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="-10 -10 220 220">
          <defs>
          <linearGradient id="transparent" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={'rgba(' + color + ', 0)'} stopOpacity="0"/>
            <stop offset="100%" stopColor={'rgba(' + color + ', 0)'} stopOpacity="0"/>
          </linearGradient>
          <linearGradient id="one" gradientUnits="objectBoundingBox" x1="1" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={'rgba(' + color + ', 0)'} stopOpacity="0"/>
            <stop offset="100%" stopColor={'rgba(' + color + ', 0.33)'}/>
          </linearGradient>
          <linearGradient id="two" gradientUnits="objectBoundingBox" x1="1" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor={'rgba(' + color + ', 0.33)'} />
            <stop offset="100%" stopColor={'rgba(' + color + ', 0.66)'}/>
          </linearGradient>
          <linearGradient id="three" gradientUnits="objectBoundingBox" x1="0" y1="1" x2="0" y2="0">
            <stop offset="0%" stopColor={'rgba(' + color + ', 0.66)'} />
            <stop offset="100%" stopColor={'rgba(' + color + ', 1)'} />
          </linearGradient>
          <linearGradient id="four" gradientUnits="objectBoundingBox" x1="0" y1="1" x2="1" y2="0">
            <stop offset="0%" stopColor={'rgba(' + color + ', 1)'} />
            <stop offset="100%" stopColor={'rgba(' + color + ', 1)'} />
          </linearGradient>
          <linearGradient id="five" gradientUnits="objectBoundingBox" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor={'rgba(' + color + ', 1)'} />
            <stop offset="100%" stopColor={'rgba(' + color + ', 1)'} />
          </linearGradient>
          </defs>

          <g fill="none" strokeWidth="20" transform="translate(100,100)">
            <path d="M 86.6,-50 A 100,100 0 0,1 86.6,50" stroke="url(#transparent)"/>
            <path d="M 86.6,50 A 100,100 0 0,1 0,100" stroke="url(#one)" />
            <path d="M 0,100 A 100,100 0 0,1 -86.6,50" stroke="url(#two)" />
            <path d="M -86.6,50 A 100,100 0 0,1 -86.6,-50" stroke="url(#three)"/>
            <path d="M -86.6,-50 A 100,100 0 0,1 0,-100" stroke="url(#four)" />
            <path d="M 0,-100 A 100,100 0 0,1 86.6,-50" stroke="url(#five)" strokeLinecap="round"/>
          </g>
        </svg>
      </div>
    );
  }
}

Loader.propTypes = {
  className: PropTypes.string,
  light: PropTypes.bool,
  block: PropTypes.bool,
};

export default withStyles(s)(Loader);



// WEBPACK FOOTER //
// ./src/components/Loader/Loader.js